export default __webpack_public_path__ + "assets/images/efc37d0439c9fcf49d32076ba456e147.png";